import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/auth-context";
import { redirectToParentLogin } from "@/services/ginjaAuth";

export function PrivateRoute() {
  const { isLoading, isAuthenticated } = useAuth();
  const sentToParent = useRef(false);

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    if (sentToParent.current) return;
    sentToParent.current = true;
    redirectToParentLogin();
  }, [isLoading, isAuthenticated]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-label="Loading" />
        <p className="text-sm text-muted-foreground">Checking your session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-hidden />
        <p className="text-sm text-muted-foreground">Redirecting to sign in…</p>
      </div>
    );
  }

  return <Outlet />;
}
